import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user:{},
    testvuex: false
  },
  mutations: {
    login(state, user) {
      state.hasLogin = true;
      state.user = user;
    },

  },
  getters: {

  },
  actions: {
    
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js